/** Durations Veo / common OpenRouter video models accept. */
export const VIDEO_DURATION_OPTIONS = [4, 6, 8];
/** App-wide default video model (OpenRouter slug). */
export const DEFAULT_VIDEO_MODEL = "google/veo-3.1-lite";
/** Snap any requested length to the nearest supported video duration (tie → 6). */
export function snapVideoDuration(seconds) {
    const n = Math.round(Number(seconds));
    if (!Number.isFinite(n))
        return 6;
    let best = 6;
    let bestDist = Infinity;
    for (const d of VIDEO_DURATION_OPTIONS) {
        const dist = Math.abs(d - n);
        if (dist < bestDist || (dist === bestDist && d === 6)) {
            best = d;
            bestDist = dist;
        }
    }
    return best;
}
//# sourceMappingURL=duration.js.map